module.exports = __webpack_public_path__ + "assets/assets/images/icons/icon-phone-accent.30d83b25.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/icon-phone-accent.svg
// module id = 340
// module chunks = 2